import { WifiOff } from 'lucide-react'

import { ErrorState } from '@/components/ui/ErrorState'
import { Container } from '@/components/ui/Container'
import { getLocalizedPath } from '@/content/i18n'
import { siteContent } from '@/content/siteContent'
import { useDirection } from '@/hooks/useDirection'
import { useLocale } from '@/hooks/useLocale'
import { getLocalizedValue } from '@/lib/utils'

export function NetworkErrorPage() {
  const locale = useLocale()
  useDirection(locale)

  return (
    <div className="min-h-screen bg-page-radial py-24">
      <Container className="flex justify-center">
        <ErrorState
          icon={<WifiOff className="h-6 w-6" />}
          title={getLocalizedValue(siteContent.errors.network.title, locale)}
          description={getLocalizedValue(siteContent.errors.network.description, locale)}
          actions={[
            { label: locale === 'ar' ? 'العودة للرئيسية' : 'Return home', to: getLocalizedPath(locale) },
            { label: locale === 'ar' ? 'إعادة المحاولة' : 'Retry later', to: getLocalizedPath(locale, 'contact'), variant: 'ghost' },
          ]}
        />
      </Container>
    </div>
  )
}
